// Search
var searchTool = document.querySelector('.header-tools-item--search');
var searchTool2 = document.querySelector('.header-search');
var searchPopup = document.querySelector('.search-popup');
var searchClose = document.querySelector('.search-close');


searchTool.addEventListener('click', function() {
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
})

searchTool2.addEventListener('click', function() {
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
})

if (searchClose) {
    searchClose.addEventListener('click', function () {
        document.body.classList.remove('search-open');
        searchPopup.classList.add('hideX');
        searchPopup.classList.remove('showX');
    })
}



// Accessibar
function eventFire(el, etype){
    if (el.fireEvent) {
        el.fireEvent('on' + etype);
    } else {
        let evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
    }
}




// Profils
if (window.innerWidth > 960) {
    var profileBtn = document.querySelector('.header-profil-search .header-profil');
}

else {
    var profileBtn = document.querySelector('#nav-main .header-profil');
}

!!profileBtn && profileBtn.addEventListener('click', function () {
    if (window.innerWidth > 960) {
        document.querySelector('.header-profil-search .header-profil__content').classList.toggle('header-profil__content--show');
        document.querySelector('.header-profil-search .header-profil').classList.toggle('header-profil--active');
    }
    
    else {
        document.querySelector('#nav-main .header-profil__content').classList.toggle('header-profil__content--show');
    }
})